import { FC } from 'react';
import { ICodeFieldContainerProps, CodeFieldContainer } from './CodeFieldContainer';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

export interface ICodeFieldFormikWrapperProps extends ICodeFieldContainerProps {
  formikProps: FormikProps<any>;
  name: string;
}

export const CodeFieldFormikWrapper: FC<ICodeFieldFormikWrapperProps> = (props) => {
  const { formikProps, name, length, ...rest } = props;
  const { errors, touched, values, setFieldValue } = formikProps;

  const { t } = useTranslation();

  const getErrorMessage = (): string => {
    if (!errors[name] || !touched[name]) return '';
    if (typeof errors[name] === 'string') return t(`${errors[name]}`);
    const { data, message }: any = errors[name];
    return t(message, data);
  };

  const handleChange = (name: string, value: string) => {
    setFieldValue(name, value);
  };

  return (
    <CodeFieldContainer
      error={getErrorMessage()}
      value={values[name]}
      onChange={handleChange}
      onBlur={() => {
        if (!formikProps.touched[name]) {
          formikProps.setFieldTouched(name);
        }
      }}
      name={name}
      length={length}
      {...rest}
    />
  );
};
